var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ProfileOptionSelector',{attrs:{"model":'school',"nextRoute":function (item) { return (item.id === 5 ? 'JobCategoryPage' : 'SchoolTypePage'); }}})}
var staticRenderFns = []

export { render, staticRenderFns }